import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { selectEvent } from "store/actions"

const ExperienceToggle = ({ selectedEvents, selectEvent, experience }) => {
  const handleCheckItem = (checked, item) => {
    selectEvent(item, checked)
  }
  return (
    <input
      type="checkbox"
      checked={
        selectedEvents.findIndex(x => x === experience.id) < 0 ? false : true
      }
      onChange={event => handleCheckItem(event.target.checked, experience)}
    />
  )
}

const mapStateToProps = state => ({
  selectedEvents: state.experiences.selectedEvents,
})

const mapDispatchToProps = dispatch => ({
  selectEvent: (item, checked) => dispatch(selectEvent(item, checked)),
})

ExperienceToggle.propType = {
  experience: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(ExperienceToggle)
